import React from 'react';
import ReactDOM from 'react-dom/client';
import { Text } from 'react-native';
import { systemSansFont } from '../theme/tokens';
import { startReleaseMonitor } from '../utils/releaseMonitor';
import App from '../app';

// Global default font so every <Text> inherits the mature Jellyflix
// system-sans stack. Screens with explicit fontFamily override this.
const textComponent = Object(Text);
textComponent.defaultProps = textComponent.defaultProps ?? {};
textComponent.defaultProps.style = { fontFamily: systemSansFont };

// Inject a root-level font-family rule so non-Text elements (inputs,
// placeholders, etc.) also use the mature stack instead of browser defaults.
const style = document.createElement('style');
style.textContent = `html,body,#root{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif}`;
document.head.appendChild(style);

startReleaseMonitor();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
